import React, { useState,useRef, useEffect } from "react";
import { Box, Typography, Card, CardContent, Avatar, CardMedia, Tabs, Tab } from "@mui/material";
import VerifiedIcon from '@mui/icons-material/Verified';
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import EuroIcon from '@mui/icons-material/Euro';
import MoneyOutlined from '@mui/icons-material/MoneyOutlined';
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { useAuth } from "../contexts/AuthContext";
import { Link } from "react-router-dom";
import "./homePage.css?v=1.0";
import api from "../api/api";
import Sidebar from "./Sidebare";
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import LikeButton from "../components/LikeButton";
import FollowButton from "../components/FollowButton";
import PostDescription from "../components/PostDescription";
import News from "../components/News";
import "./Profile.css?v=1.0"; 
import PostulerButton from "../components/PostulerButton";

const HomePage = () => {
  const { user } = useAuth();
  const [tabValue, setTabValue] = React.useState(0);
  const [publications, setPublications] = React.useState([]);
  const [programmes, setProgrammes] = React.useState([]);
  const [universities, setUniversities] = React.useState([]);
  const [openModal, setOpenModal] = useState(false);

  const timeAgo = (date) => {
    const formatted = formatDistanceToNow(new Date(date), { addSuffix: true, locale: fr });
    return formatted.includes("il y a moins d’une minute") ? "à l'instant" : formatted;
  };
  

  useEffect(() => {
    api.get('/publications')
      .then(response => setPublications(response.data))
      .catch(error => console.error('Erreur lors du chargement des publications:', error));

    api.get('/programs')
      .then(response => setProgrammes(response.data))
      .catch(error => console.error('Erreur lors du chargement des programmes:', error));

    api.get('/universities')
      .then(response => setUniversities(response.data))
      .catch(error => console.error('Erreur lors du chargement des universités:', error));
  }, []);


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const switchIsFollowing = () => {
    console.log("Button clicked!!")
  };


  const candidater = () => {
    handleOpenModal()
  };


  const handleOpenModal = () => {
  
    setOpenModal(true);
  };
  
  return (
    <Box display="flex">
      <Sidebar  userProfile={user} />

      <Box className="profile-container">

        <Box>
          <Tabs
            value={tabValue}
            scrollButtons="auto"
            allowScrollButtonsMobile={true}
            onChange={handleTabChange}
            className="tabs"
            TabIndicatorProps={{ style: { background: "#27aae0" } }}
          >
            <Tab label="Publications" />
            <Tab label="Universités" />
            <Tab label="Formations" />
          </Tabs>

          <Box className="scrollable-content">
            {tabValue === 0 && (
              <>
                {publications.map((post) => (
                  <Card key={post._id} className="publication-card">
                    <CardContent>
                      <Box className="post-header">
                        <Link to={`/profile/${post.universityId._id}`}>
                        <Avatar src={post.universityId.photo} alt={post.university} className="post-avatar" />
                        </Link>
                        <div style={{ textAlign: "left", flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            
                            <Typography variant="h6" className="university-name">
                              <Link to={`/profile/${post.universityId._id}`} style={{ textDecoration: 'none', color: 'inherit', marginRight:"5px" }}>
                                {post.universityId.name}
                              </Link>
                            </Typography>

                            <VerifiedIcon style={{ color: "#27aae0", fontSize: "18px" }}  />
                          </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                            <Typography variant="body2" className="university-type" style={{ color: "#6c757d" }}>
                              université privée
                            </Typography>
                            <Typography variant="body2" className="university-type" style={{ color: "#6c757d" }}>
                                {post.universityId.address.city} / {post.universityId.address.country}
                                <PlaceOutlinedIcon style={{ verticalAlign: "middle" }} />
                            </Typography>
                            
                            </div>
                        </div>
                      </Box>

                      <PostDescription text={post.content} />

                      <CardMedia
                        component="img"
                        image={post.attachments[0]}
                        alt="Post Image"
                        className="post-image"
                      />
                      
                      <Box className="post-actions" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <Typography style={{ color: "#6c757d", fontSize: "0.875rem" }}>
                          <p>{timeAgo(post.createdAt)}</p>
                        </Typography>

                        <LikeButton
                          post={post}
                          updatePostLikes={(postId, change, likesCount) => {
                            setPublications((prev) =>
                              prev.map((p) =>
                                p._id === postId
                                  ? {
                                      ...p,
                                      likes: likesCount !== undefined ? new Array(likesCount).fill("like") : [...p.likes, "like"].slice(0, p.likes.length + change),
                                    }
                                  : p
                              )
                            );
                          }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </>
            )}

            {tabValue === 1 && (
              <>
                {universities.map((post) => (
                  <Card
                  key={post._id}
                  className="university-card"
                  sx={{
                    borderRadius: 3,
                    boxShadow: 3,
                    overflow: "hidden",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": { boxShadow: 6 },
                  }}
                >
                  {/* Image de couverture */}
                  <CardMedia
                    component="img"
                    height="150"
                    image={post.coverPhoto || "https://ega-senegal.com/uploads/cover_default.jpeg"}
                    alt="University Cover"
                    sx={{ objectFit: "cover" }}
                  />
                
                  <CardContent sx={{ position: "relative", textAlign: "center", pt: 5 }}>
                    {/* Avatar avec effet superposé sur la bannière */}
                    <Link to={`/profile/${post._id}`}>
                    <Avatar
                      src={post.photo || "https://ega-senegal.com/uploads/photo_default.jpg"}
                      alt={post.name}
                      sx={{
                        width: 80,
                        height: 80,
                        border: "4px solid white",
                        position: "absolute",
                        top: "-40px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    />
                    </Link>
                
                    {/* Informations */}
                    <Link to={`/profile/${post._id}`}>
                    <Typography variant="h6" fontWeight="bold" mt={1}>
                      {post.name}
                    </Typography>
                    </Link>
                    <Typography variant="body2" color="textSecondary">
                      {post.address.city}, {post.address.country}
                    </Typography>
                
                    {/* Bouton d'abonnement */}
                    {user ? user._id !== post._id && (
                    <FollowButton
                      id={"followbutton"}
                      universityId={post._id}
                      isFollowing={Array.isArray(post.listAbonnements) && post.listAbonnements.includes(user._id)}
                      onClick={switchIsFollowing}
                    />
                    ) : ""}
                  </CardContent>
                </Card>
                
                
                ))}
              </>
            )}

            {tabValue === 2 && (
              <>
                {programmes.map((element) => (
                  <Card key={element.id} className="programm-card">
                    <CardContent>
                        <Box display="flex" alignItems="center">
                        <Link to={`/profile/${element.universityId._id}`}>
                          <Avatar
                            src={element.photo}
                            alt={element.title}
                            className="post-avatar"
                          />
                          </Link>
                          <div style={{ textAlign: "left", marginLeft: "10px" }}>
                            <Typography variant="h6" className="university-name">
                              {element.title}
                            </Typography>
                            <Typography variant="body2" className="university-type">
                              {element.universityId.name}
                            </Typography>
                          </div>
                        </Box>
                      <CardMedia
                        component="img"
                        image={element.attachments[0]}
                        alt="Post Image"
                        className="programm-image"
                      />

                      <Box
                        style={{
                          textAlign: "center",
                          marginTop: "16px",
                        }}
                      >
                        <Typography className="post-description">{element.description}</Typography>
                      </Box>

                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          gap: "16px",
                          marginTop: "16px",
                        }}
                      >
                        <Typography style={{ color: "#6c757d", fontSize: "0.875rem", textAlign: "center" }}>
                          <PlaceOutlinedIcon style={{ verticalAlign: "middle", marginBottom: "1px" }} />
                          <p> {element.universityId.address.city} / {element.universityId.address.country} </p>
                        </Typography>
                        <Typography style={{ color: "#6c757d", fontSize: "0.875rem", textAlign: "center" }}>
                          <AccessTimeOutlinedIcon style={{ verticalAlign: "middle", marginBottom: "1px" }} />
                          <p> {element.duration} </p>
                        </Typography>
                        <Typography style={{ color: "#6c757d", fontSize: "0.875rem", textAlign: "center" }}>
                          <EuroIcon style={{ verticalAlign: "middle", marginBottom: "1px" }} />
                          <p> {element.price} </p>
                        </Typography>
                      </Box>

                        {(user && user.type==="student") ? (
                          <PostulerButton
                          programId={element._id}
                          canCandidate={user.canCandidate}
                          isCandidate={Array.isArray(element.applications) && element.applications.includes(user._id)}
                          onClick={candidater}
                          />
                        ) : (
                          ""
                        )}
                      

                    </CardContent>
                  </Card>
                ))}
              </>
            )}
          </Box>
        </Box>

      </Box>

      <Box className="sidebar-right">
        <News />
      </Box>
    </Box>
  );
};

export default HomePage;